/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLootBoxPrizeBody
 */
export interface UpdateLootBoxPrizeBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateLootBoxPrizeBody
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLootBoxPrizeBody
     */
    rewardConfigId?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateLootBoxPrizeBody
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLootBoxPrizeBody
     */
    weight?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLootBoxPrizeBody
     */
    sortOrder?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLootBoxPrizeBody
     */
    onlyAvailableAfterWins?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateLootBoxPrizeBody
     */
    image?: string;
}

/**
 * Check if a given object implements the UpdateLootBoxPrizeBody interface.
 */
export function instanceOfUpdateLootBoxPrizeBody(value: object): value is UpdateLootBoxPrizeBody {
    return true;
}

export function UpdateLootBoxPrizeBodyFromJSON(json: any): UpdateLootBoxPrizeBody {
    return UpdateLootBoxPrizeBodyFromJSONTyped(json, false);
}

export function UpdateLootBoxPrizeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLootBoxPrizeBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'rewardConfigId': json['rewardConfigId'] == null ? undefined : json['rewardConfigId'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'onlyAvailableAfterWins': json['onlyAvailableAfterWins'] == null ? undefined : json['onlyAvailableAfterWins'],
        'image': json['image'] == null ? undefined : json['image'],
    };
}

export function UpdateLootBoxPrizeBodyToJSON(json: any): UpdateLootBoxPrizeBody {
    return UpdateLootBoxPrizeBodyToJSONTyped(json, false);
}

export function UpdateLootBoxPrizeBodyToJSONTyped(value?: UpdateLootBoxPrizeBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'rewardConfigId': value['rewardConfigId'],
        'quantity': value['quantity'],
        'weight': value['weight'],
        'sortOrder': value['sortOrder'],
        'onlyAvailableAfterWins': value['onlyAvailableAfterWins'],
        'image': value['image'],
    };
}

